/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Int32CriteriaRangeOutput
 */
export interface Int32CriteriaRangeOutput {
    /**
     * 
     * @type {boolean}
     * @memberof Int32CriteriaRangeOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Int32CriteriaRangeOutput
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof Int32CriteriaRangeOutput
     */
    to?: number;
}

export function Int32CriteriaRangeOutputFromJSON(json: any): Int32CriteriaRangeOutput {
    return Int32CriteriaRangeOutputFromJSONTyped(json, false);
}

export function Int32CriteriaRangeOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): Int32CriteriaRangeOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
    };
}

export function Int32CriteriaRangeOutputToJSON(value?: Int32CriteriaRangeOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'from': value.from,
        'to': value.to,
    };
}


